var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"searchno-div"},[_c('div',{staticClass:"searchno-img"},[_c('img',{attrs:{"src":_vm.nocityicon,"alt":""}})]),_c('div',{staticClass:"searchno-div-text"},[_vm._v(_vm._s(_vm.nofindtext))])])])}
var staticRenderFns = []

export { render, staticRenderFns }